import { render } from "./ImageTable.vue?vue&type=template&id=49420948&scoped=true&ts=true"
import script from "./ImageTable.vue?vue&type=script&lang=ts"
export * from "./ImageTable.vue?vue&type=script&lang=ts"

import "./ImageTable.vue?vue&type=style&index=0&id=49420948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49420948"]])

export default __exports__